export default "__VITE_ASSET__CdgMF4Js__"